var CandidateCardQueryFilter = /** @class */ (function () {
    function CandidateCardQueryFilter(companyId, userId) {
        this.parentCompanyId = companyId;
        this.loggedInUserId = userId;
        this.status = [];
        this.roleList = [];
        this.recruiterList = [];
        this.requisitionNumbers = [];
        this.clientOrBuList = [];
        this.requisitionStatus = [];
        this.workflowStates = [];
        this.vendorIds = [];
        this.candidateType = "OWN_CANDIDATES";
    }
    return CandidateCardQueryFilter;
}());
export { CandidateCardQueryFilter };
//# sourceMappingURL=candidateCardQueryFilter.js.map